// extracted by css-extract-rspack-plugin
export default {"PrimerLink":"DirectoryRow-module__PrimerLink__COEaW","Box":"DirectoryRow-module__Box__hrMJ9","Octicon":"DirectoryRow-module__Octicon__mOawz"};